import { render, staticRenderFns } from "./Sponse.vue?vue&type=template&id=5d1cbfc4&scoped=true&"
import script from "./Sponse.vue?vue&type=script&lang=js&"
export * from "./Sponse.vue?vue&type=script&lang=js&"
import style0 from "./Sponse.vue?vue&type=style&index=0&id=5d1cbfc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1cbfc4",
  null
  
)

export default component.exports